import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);

  useEffect(() => { api.get("/admin/users?limit=200").then((r) => setUsers(r.data)); }, []);

  const flag = async (user_id, flagVal) => {
    try {
      await api.post("/admin/fraud/flag", { user_id, flag: flagVal });
      toast.success(`User flagged: ${flagVal}`);
    } catch (e) {
      toast.error("Couldn't flag");
    }
  };

  return (
    <div data-testid="adm-users-page">
      <PageHeader eyebrow="People" title="User management" subtitle="All users, roles, and fraud flags." />

      <Card className="border-gray-200 shadow-none rounded-2xl">
        <CardContent className="p-0">
          <table className="w-full text-sm">
            <thead className="border-b border-gray-200 bg-gray-50">
              <tr className="text-left">
                <th className="px-5 py-3 font-semibold">Name</th>
                <th className="px-5 py-3 font-semibold">Email</th>
                <th className="px-5 py-3 font-semibold">Role</th>
                <th className="px-5 py-3 font-semibold">Onboarded</th>
                <th className="px-5 py-3 font-semibold">Premium</th>
                <th className="px-5 py-3 font-semibold">Joined</th>
                <th className="px-5 py-3 font-semibold w-44">Compliance</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-gray-100" data-testid={`adm-user-${u.id}`}>
                  <td className="px-5 py-3 font-medium">{u.name}</td>
                  <td className="px-5 py-3 text-gray-600">{u.email}</td>
                  <td className="px-5 py-3"><Badge variant="outline" className="capitalize">{u.role.replace("_", " ")}</Badge></td>
                  <td className="px-5 py-3">{u.onboarded ? <Badge className="bg-emerald-50 text-emerald-800 border border-emerald-200">Yes</Badge> : <Badge variant="outline">No</Badge>}</td>
                  <td className="px-5 py-3">{u.premium ? <Badge className="bg-amber-50 text-amber-800 border border-amber-200">Premium</Badge> : "—"}</td>
                  <td className="px-5 py-3 text-gray-500">{new Date(u.created_at).toLocaleDateString()}</td>
                  <td className="px-5 py-3">
                    <Select onValueChange={(v) => flag(u.id, v)}>
                      <SelectTrigger className="h-8 text-xs"><SelectValue placeholder="Set flag" /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="clear">Clear</SelectItem>
                        <SelectItem value="watch">Watch</SelectItem>
                        <SelectItem value="review">Manual review</SelectItem>
                        <SelectItem value="suspended">Suspended</SelectItem>
                      </SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
